"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useControlState = void 0;
const react_1 = require("react");
const useControlState = ({ onBlur, rootRef, onFocus, onPreventBlur } = {}) => {
    const preventBlurFlagRef = (0, react_1.useRef)(false);
    const [focused, setFocused] = (0, react_1.useState)(false);
    const [active, setActive] = (0, react_1.useState)(false);
    const focus = () => {
        setFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    };
    const blur = () => {
        setFocused(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    };
    const activate = () => {
        setActive(true);
    };
    const deactivate = () => {
        setActive(false);
    };
    const preventBlur = () => {
        preventBlurFlagRef.current = true;
    };
    return {
        focused,
        active,
        focus,
        blur,
        input: {
            onBlur: (event) => {
                var _a;
                event === null || event === void 0 ? void 0 : event.stopPropagation();
                if (preventBlurFlagRef.current) {
                    preventBlurFlagRef.current = false;
                    (_a = rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    onPreventBlur === null || onPreventBlur === void 0 ? void 0 : onPreventBlur();
                    return;
                }
                blur();
                deactivate();
            },
            onFocus: (event) => {
                event === null || event === void 0 ? void 0 : event.stopPropagation();
                focus();
            }
        },
        activate,
        deactivate,
        preventBlur
    };
};
exports.useControlState = useControlState;
//# sourceMappingURL=useControlState.js.map